export default "{\n    \"workOrdersBreadcrumbLabel\": \"Work Orders\",\n    \"heading\": \"Edit Work Order\",\n    \"submitButtonLabel\": \"Save\"\n}\n"